import uiRouter from '@uirouter/angularjs/lib-esm'
/*import user from '../SlotTrak.User'*/

import loginDirective from './Pages/login/directive'
import loginRoutes from './routes'

var mod = angular.module('SlotTrak.Login', [
  uiRouter,
  /*user*/
])

mod
  .config(loginRoutes)
  .directive('login', loginDirective)

export default mod.name
